import { Directive, HostListener, computed, inject } from '@angular/core';
import { NavigationAdapter, ProfileService } from '@partners/kernel';
import { TCloseAction } from '@partners/settings';
import { ShellStore } from '@partners/state';

@Directive({
  selector: '[applicationClose]',
  standalone: true
})
export class AppCloseDirective {
  private _shellStore = inject(ShellStore);
  private _navAdapter = inject(NavigationAdapter);
  private _profileService = inject(ProfileService);

  closeAction = computed<TCloseAction>(() => {
    const viewSettings = this._shellStore.viewSettings$$();
    return viewSettings?.headerCloseAction;
  });

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent | TouchEvent): void {
    const { headerCloseAction } = this._shellStore.viewSettings$$();
    switch (headerCloseAction) {
      case 'confirm-exit':
        this._navAdapter.toConfirm('exit-confirm');
        break;
      case 'move-previous':
        this._navAdapter.moveBack();
        break;
      default:
        this._profileService.terminateProcess('customer-opt-out');
        break;
    }
  }

  constructor() {}
}
